import React from 'react'
import './TimetablePreview.module.css'

const TimetablePreview = () => (
    <img
        styleName="preview"
        src="https://s3.eu-central-1.amazonaws.com/assets.beatswitch.com/promoter-web-app/timetable-web-embed-mockup.png"
        alt="Timetable preview"
    />
);

export default TimetablePreview;
